import type {IOptionModel} from "@/models/option";

export enum OrganizationStatus {
    Inactive = 0,
    Active = 1,
    ReadOnly = 2,
}

export const OrganizationStatusOptions: IOptionModel<number>[] = [
    {
        label: "core.organization_status.active",
        value: OrganizationStatus.Active
    },
    {
        label: "core.organization_status.inactive",
        value: OrganizationStatus.Inactive
    },
    {
        label: "core.organization_status.read_only",
        value: OrganizationStatus.ReadOnly
    },
];
